import Navigation from "./Navigation";
import Footer from "./Footer";
import Background from "./Background";

const H1 = ({ children }) => (
  <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.02] text-[#F5EFE6]">
    {children}
  </h1>
);

const H2 = ({ children }) => (
  <h2 className="mt-12 font-display text-xl md:text-2xl font-bold text-[#F5EFE6]">
    {children}
  </h2>
);

const P = ({ children }) => (
  <p className="mt-4 text-[15px] leading-relaxed text-[#CFC6BC]">{children}</p>
);

const UL = ({ items }) => (
  <ul className="mt-4 space-y-2 text-[15px] leading-relaxed text-[#CFC6BC]">
    {items.map((t, i) => (
      <li key={i} className="pl-5 relative">
        <span className="absolute left-0 top-2 h-1.5 w-1.5 rounded-full bg-[#D9A441]" />
        {t}
      </li>
    ))}
  </ul>
);

export const LegalLayout = ({ scrollTo, kind, updated, children }) => (
  <>
    <Navigation scrollTo={scrollTo} />
    <main className="relative min-h-screen overflow-hidden" data-testid={`${kind}-page`}>
      <Background />
      <section className="relative z-10 px-6 pt-40 pb-24">
        <div className="mx-auto max-w-3xl">
          <p className="mb-8 text-xs uppercase tracking-[0.4em] text-[#D9A441]">
            Legal · Last updated {updated}
          </p>
          {children}
        </div>
      </section>
      <Footer scrollTo={scrollTo} />
    </main>
  </>
);

export { H1, H2, P, UL };
